package com.zq.webproject.model

import kotlinx.serialization.Serializable

/**
 * 购买记录响应数据模型
 */
@Serializable
data class PurchaseRecordResponse(
    val code: Int,
    val message: String,
    val data: List<PurchaseRecord>
)

/**
 * 购买记录数据模型
 */
@Serializable
data class PurchaseRecord(
    val orderId: Int,
    val orderNo: String,
    val userId: Int,
    val productId: Int,
    val productPrice: Double,
    val payStatus: Int,  // 支付状态：0-未支付，1-已支付
    val profitDistributed: Int,  // 分润状态：0-未分润，1-已分润
    val orderTime: String,
    val productName: String,
    val productCurrentPrice: Double,
    val productCategory: String,
    val productImage: String,
    val productDescription: String,
    val productImage3: String? = null  // 百度网盘链接，可能为null
) {
    /**
     * 获取支付状态文本
     */
    fun getPayStatusText(): String {
        return when (payStatus) {
            0 -> "未支付"
            1 -> "已支付"
            else -> "未知状态"
        }
    }

    /**
     * 获取分润状态文本
     */
    fun getProfitDistributedText(): String {
        return when (profitDistributed) {
            0 -> "未分润"
            1 -> "已分润"
            else -> "未知状态"
        }
    }
}